import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import InputSelect from '../../Forms/InputSelect.jsx';
import { DEFAULT_CONFERENCE_ID, useStateContext } from '../../Contexts/ContextProvider.jsx';
import AxiosClient from '../../assets/AxiosClient.js';
import ExcelExportButton from '../../assets/ExcelExportButton.jsx';
import ConferenceDropdown from '../../Forms/ConferenceDropdown.jsx';
import Declinedrow from './Declinedrow.jsx';
import Loader from '../../assets/tools/Loder/loader';

const Declineds = () => { 
  const {LastSelectedConference} = useStateContext() ; 
  const { SetNotification } = useStateContext();
  const [Declineds, setDeclineds] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showFilter, setShowFilter] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [attendPerPage, setAttendPerPage] = useState(20);
  const [nameFilter, setNameFilter] = useState('');
  const [selectedCountry, setSelectedCountry] = useState(''); 
  const [countries, setCounrtyList] = useState([]); 
  const [selectedDates, setselectedDates] = useState('');
  const [isSend, setIsSend] = useState(false);  
  const [conferenceId, setConferenceId] = useState(DEFAULT_CONFERENCE_ID);
  const abortController = new AbortController(); // Create a new AbortController instance

  useEffect(() => {
    const fetchData = async () => {
      if (!conferenceId) return; // Don't fetch if conferenceId is not set

      setLoading(true); // Set loading to true while fetching data
      try {
        const response = await AxiosClient.get(`/Registeration/Declineds/${conferenceId}`, {
          signal: abortController.signal // Attach the AbortController signal
        }); 
        console.log(response.data) ;
        const { users } = await response.data;
        setDeclineds(users);
        setCounrtyList(Array.from(new Set(users.map(user => user.country))));
        setLoading(false); // Set loading to false after data is fetched
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('Error fetching data:', error);
        }
        setLoading(false); // Ensure loading is turned off in case of an error
      }
    };

    fetchData();
    
    return () => {
      abortController.abort(); // Cleanup on component unmount or if conferenceId changes
    };
  }, [conferenceId]);  // Fetch data when conferenceId changes

  const filterDeclineds = () => {
    let filteredDeclineds = Declineds;
    if (showFilter === 'Researcher') {
      filteredDeclineds = filteredDeclineds.filter(user => user.role === 'Researcher');
    } else if (showFilter === 'Guest') {
      filteredDeclineds = filteredDeclineds.filter(user => user.role === 'Guest');
    }

    // Filter by name
    if (nameFilter.trim() !== '') {
      filteredDeclineds = filteredDeclineds.filter(user =>
        user.name.toLowerCase().includes(nameFilter.trim().toLowerCase())
      );
    }

    // Filter by date
    if (selectedDates) {
      filteredDeclineds = filteredDeclineds.filter(user => user.attendance_date.includes(selectedDates));
    }

    // Filter by country
    if (selectedCountry) {
      filteredDeclineds = filteredDeclineds.filter(user =>
        user.country.toLowerCase() === selectedCountry.toLowerCase()
      );
    }

    return filteredDeclineds;
  };

  const indexOfLastAttend = currentPage * attendPerPage;
  const indexOfFirstAttend = indexOfLastAttend - attendPerPage;
  const currentAttends = filterDeclineds().slice(indexOfFirstAttend, indexOfLastAttend);
  const ExeilData = filterDeclineds(); 
  const paginate = pageNumber => setCurrentPage(pageNumber);

  const handelResend = async () => {
    const report = [];
    const confirmed = window.confirm(`Resend acceptance mail?`);
    if (!confirmed) {
      return;
    }
    setIsSend(true);
    for (const user of ExeilData) {
      try {
        const response = await AxiosClient.get(`/Tools/resend-accept-mail/${user.id}`);

        if (response.status === 200) {
          // Successful response
          report.push({ user: user.name, mail: user.email, status: "Done" });
          SetNotification('Mail has been sent to user', 'success');
        }
      } catch (error) {
        // Error occurred
        report.push({ user: user.name, mail: user.email, status: "Error" });
        SetNotification('Error occurred while sending mail to user', 'danger');
      }
    }

    // Convert report array to text format
    const reportText = report.map(entry => `${entry.user}, ${entry.mail}, ${entry.status}`).join('\n');

    // Trigger download of the report as a text file
    const blob = new Blob([reportText], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = 'resend_report.txt';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (
    <section className="p-4">
      <div className="card border-0 shadow-sm rounded-4 p-3 mb-4">
      </div>

      {loading ? (
        <div className="card border-0 shadow-sm rounded-4 p-4">
          <Loader label="Loading declined registrations..." />
        </div>
      ) : (
        <>
          <div className="card border-0 shadow-sm rounded-4 p-3 mb-4">
            <div className="row g-3 align-items-end">
              <div className="col-lg-4 col-md-6">
                <label className="form-label fw-semibold">Search by name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Filter by name"
                  value={nameFilter}
                  onChange={(e) => setNameFilter(e.target.value)}
                />
              </div>

              <div className="col-lg-3 col-md-6">
                <InputSelect
                  title={"Filter by country"}
                  array={countries}
                  val={selectedCountry}
                  setval={setSelectedCountry}
                />
              </div>

              <div className="col-lg-3 col-md-6">
                <InputSelect
                  val={selectedDates}
                  setval={setselectedDates}
                  array={['2025-04-27', '2025-04-28', '2025-04-29']}
                  title={"Select day"}
                />
              </div>

              <div className="col-lg-2 col-md-12">
                <div className="d-flex flex-wrap gap-2">
                  <button className="btn btn-outline-primary" onClick={() => setShowFilter('Researcher')}>
                    Researchers
                  </button>
                  <button className="btn btn-outline-warning" onClick={() => setShowFilter('Guest')}>
                    Guests
                  </button>
                  <button className="btn btn-outline-secondary" onClick={() => setShowFilter(null)}>
                    All
                  </button>
                </div>
              </div>
            </div>

            <div className="dashboard-actions mt-3">
              <ExcelExportButton data={Declineds} fileName="Declineds" label="Export all" />
              <ExcelExportButton data={ExeilData} fileName="filtered" label={"Export filtered"} />
              {!isSend && (
                <button className="btn btn-info text-white" onClick={handelResend}>
                  <i className="material-icons opacity-10 mx-2">mail</i>
                  Remind selection
                </button>
              )}
            </div>
          </div>

          <div className="card border-0 shadow-sm rounded-4 p-0 overflow-hidden">
            <div className="table-responsive">
              <table className="table align-middle mb-0">
                <thead className="table-light">
                  <tr>
                    <th className="ps-4">Image</th>
                    <th>Full Name</th>
                    <th>Position</th>
                    <th>Nationality</th>
                    <th>Type</th>
                    <th className="pe-4">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentAttends.length > 0 ? (
                    currentAttends.map((user) => <Declinedrow key={user.id} attendant={user} />)
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center py-4 text-muted">No declined registrations found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className="pagination p-3">
              {filterDeclineds().length > attendPerPage && (
                <ul className="pagination mb-0">
                  {Array(Math.ceil(filterDeclineds().length / attendPerPage))
                    .fill()
                    .map((_, index) => (
                      <li key={index} className="page-item">
                        <button className="page-link" onClick={() => paginate(index + 1)}>
                          {index + 1}
                        </button>
                      </li>
                    ))}
                </ul>
              )}
            </div>
          </div>
        </>
      )}
    </section>
  );
};

export default Declineds;
